<template>
  <div id="EventTicketsBlock" class="EventTicketsBlock">
    <div class="EventTicketsBlock__top">
      <div class="EventTicketsBlock__filter">
        <input
          id="hide-sold-out"
          v-model="hideSoldOut"
          name="hide-sold-out"
          type="checkbox"
        />
        <label for="hide-sold-out">{{ translations.hideSoldOutDates }}</label>
      </div>
    </div>
    <div v-if="loadingTickets" class="EventTicketsBlock__loader">
      <span v-for="number in 5" :key="number" class="load-bar"> </span>
    </div>
    <EventOccasionsList
      v-if="eventOccasionsList.length && !loadingTickets"
      :event-occasions-list="eventOccasionsList"
      :hide-sold-out="hideSoldOut"
    />
    <div
      v-if="!loadingTickets && !eventOccasionsList.length"
      class="EventTicketsBlock__error"
    >
      {{ translations.noItemsMessage }}
    </div>
    <div v-if="!loadingTickets && !event.tid" class="EventTicketsBlock__error">
      {{ translations.noIdMessage }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EventOccasionsList from "./components/EventOccasionsList";

export default {
  name: "EventTicketsBlock",
  components: { EventOccasionsList },
  data() {
    return {
      translations: {
        tickets: Drupal.t("Tickets"),
        hideSoldOutDates: Drupal.t("Hide sold out dates"),
        loadingTicketInfo: Drupal.t("Loading ticket information"),
        noIdMessage: Drupal.t(
          "No Klara event id is set, this block needs an ID to work"
        ),
        noItemsMessage: Drupal.t("No dates are currently available"),
      },
      hideSoldOut: false,
    };
  },
  created() {
    if (!drupalSettings.ticket_button_hide) {
      this.showTicketButton();
    }
    if (drupalSettings.show_subtitle) {
      this.showSubtitle();
    }
  },
  methods: {
    ...mapActions(["showTicketButton", "showSubtitle"]),
  },
  computed: {
    ...mapGetters({
      eventData: "getEventData",
      loadingTickets: "getLoadingTicketsState",
    }),
    event() {
      return this.eventData[drupalSettings.nid];
    },
    eventOccasionsList() {
      return this.event && this.event.dates ? this.event.dates : [];
    },
  },
};
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

.EventTicketsBlock__top {
  @include container--text;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  @include breakpoint($tablet) {
    align-items: flex-end;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 40px;
  }
}

.EventTicketsBlock__error {
  @include container--text;
  margin: 30px auto;
  text-align: center;
}

.EventTicketsBlock__heading {
  margin-bottom: 20px;
  margin-top: 0;

  @include container--text;

  @include breakpoint($tablet) {
    margin-bottom: -25px;
  }
}

.EventTicketsBlock__loader {
  overflow: hidden;
  position: relative;

  .load-bar {
    display: block;
    height: 48px;
    width: 100%;

    &:nth-child(odd) {
      background: $light-grey;
    }
  }
}
</style>
